import { forwardRef } from 'react';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef/index.ts';

import { BaseComponent } from '../BaseComponent.tsx';
import type { IconBaseProps, IconRender } from '../types.ts';

const CircleCheckmark = forwardRef<SVGSVGElement | null, IconBaseProps>(function CircleCheckmark({ dataTestId, ...props }, ref) {
  const iconRender = useCallbackRef<IconRender>((color: string) => (
    <path
      d='M7 0C10.866 0 14 3.13401 14 7C14 10.866 10.866 14 7 14C3.13401 14 0 10.866 0 7C0 3.13401 3.13401 0 7 0ZM10.8008 3.84961C10.5799 3.68375 10.2663 3.7292 10.1006 3.9502L6.48828 8.76562C6.45179 8.81428 6.38093 8.81931 6.33789 8.77637L3.88379 6.32324C3.68853 6.12798 3.37202 6.12798 3.17676 6.32324L2.82324 6.67676C2.62811 6.87203 2.62802 7.18857 2.82324 7.38379L6.5 11.0596C6.54304 11.1025 6.6139 11.0975 6.65039 11.0488L11.2998 4.84961C11.4652 4.6289 11.4206 4.31616 11.2002 4.15039L10.8008 3.84961Z'
      fill={color}
    />
  ));
  return (
    <BaseComponent
      ref={ref}
      viewBox='0 0 14 14'
      dataTestId={dataTestId ?? 'circle-checkmark-icon-svg'}
      iconRender={iconRender}
      {...props}
    />
  );
});

export default CircleCheckmark;
